

export default function handleProcessResult(process: {
  result: any,
  resultType: string,
}) {
  if (process.resultType === 'error') {
    throw process.result;
  }
  return process.result;
}